import React, { useEffect, useRef, useState } from 'react';
import { FaUsers } from 'react-icons/fa6';
import { HiPhoneMissedCall } from 'react-icons/hi';
import { MdWifiCalling3 } from 'react-icons/md';
import TraficWidget from 'Components/Common/Widget/TraficWidget';
import EngagedUsers from './components/EngagedUsers';
import AllTraficUsers from './components/AllTraficUsers';
import IdleUsers from './components/IdleUsers';
import { getAllUser } from 'Common Usage/apiService';

const Traffic = () => {
  const [usersType, setUsersType] = useState('all');
  const [users, setUsers] = useState([]);
  const [counts, setCounts] = useState({ 
    totalUsers: 0, activeUsers: 0, blockedUsers: 0 ,maleUsers: 0,
  femaleUsers: 0,});
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await getAllUser(page, searchTerm);
        setUsers(data?.data);
        setCounts(data?.counts || {});
      } catch (error) {
        console.log("getAllUser-Error", error.message);
      }
    };
    fetchUsers();
  }, [searchTerm, page]);


  const renderUsersType = (type) => {
    switch (type) {
      case 'all':
        return <AllTraficUsers users={users} searchTerm={searchTerm} setSearchTerm={setSearchTerm} page={page} setPage={setPage} counts={counts}   />;
      case 'engaged':
        return <EngagedUsers />;
      case 'idle':
        return <IdleUsers />;
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <TraficWidget icon={<FaUsers className="h-6 w-6" />} title={"Total Users"} subtitle={counts.totalUsers} />
        <TraficWidget icon={<MdWifiCalling3 className="h-6 w-6" />} title={"Total Engaged User"} subtitle={counts?.engagedUsers} />
        {/* <TraficWidget icon={<HiPhoneMissedCall className="h-6 w-6" />} title={"TotalIdle Users"} subtitle={counts?.idleUsers} /> */}
      </div>
      <div>{renderUsersType(usersType)}</div>
    </React.Fragment>
  )
}

export default Traffic;
